module.exports = __webpack_public_path__ + "static/media/tree-step-3_1.e1eb5033.svg";